const products = [
  {
    id: 1,
    title: "Khăn ướt",
    path: "./images/products/khan_uot.webp",
  },
  {
    id: 2,
    title: "Tã dán",
    path: "./images/products/ta_dan.webp",
  },
  {
    id: 3,
    title: "Sản phẩm trải nghiệm",
    path: "./images/products/bim_test.png",
  },
  {
    id: 4,
    title: "Tã quần",
    path: "./images/products/ta_quan.webp",
  },
  {
    id: 5,
    title: "Khăn giấy",
    path: "./images/products/khan_giay.png",
  },
];
export default products;
